import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {TenMeeting} from "../../_models/meetings.models";

export const loadList = createAction(
    '[Ten Meetings] Load List',
    props<{ uuid: string }>()
);

export const loadListSuccess = createAction(
    '[Ten Meetings] Load List Success',
    props<{ items: TenMeeting[] }>()
);

export const loadListFailure = createAction(
    '[Ten Meetings] Load List Failure',
    props<{ error: HttpErrorResponse }>()
);

export const loadItem = createAction(
    '[Ten Meetings] Load Item',
    props<{ itemId: string }>()
);

export const loadItemSuccess = createAction(
    '[Ten Meetings] Load Item Success',
    props<{ item: TenMeeting }>()
);

export const loadItemFailure = createAction(
    '[Ten Meetings] Load Item Failure',
    props<{ error: HttpErrorResponse }>()
);

export const setMeetingId = createAction(
    '[Ten Meetings] Set Meeting Id',
    props<{ itemId: string }>()
);
